import { style } from "@vanilla-extract/css";
import { recipe } from "@vanilla-extract/recipes";

export const textStyle = style({
  position: "relative",
  width: "100%",
});

export const ghostStyle = recipe({
  base: {},
  variants: {
    render: {
      true: {},
      false: {
        visibility: "hidden",
      },
    },
  },
});

export const typerStyle = style({
  position: "absolute",
  width: "100%",
  height: "100%",
  userSelect: "none",
});
